import React, { Component } from 'react';
import { Route, NavLink, Switch } from 'react-router-dom';

import FixedHeightWrapper from 'app/meets/FixedHeightWrapper';
import ImportLifters from './lifters/ImportLifters';
import ImportDivisions from './divisions/ImportDivisions';

import './ImportIndex.scss';

class ImportIndex extends Component {

  render() {
    const { match, onFinishBulkCreate } = this.props;

    return (
      <FixedHeightWrapper>
        <div className='import-index'>
          <div className="tabs">
            <NavLink to={`${match.url}/divisions`} className="tab" activeClassName='active'>Import Divisions</NavLink>
            <NavLink to={`${match.url}/lifters`} className="tab" activeClassName='active'>Import Lifters</NavLink>
          </div>

          <Switch>
            <Route path='/meets/:meetId/import/lifters' component={(props) => <ImportLifters {...props} onFinishBulkCreate={onFinishBulkCreate} />} />
            <Route path='/meets/:meetId/import/divisions' component={(props) => <ImportDivisions {...props} onFinishBulkCreate={onFinishBulkCreate} />} />
          </Switch>
        </div>
      </FixedHeightWrapper>
    );
  }
}

export default ImportIndex;
